import { toast } from 'react-toastify'

export const showToast = (type, message) => {
  const options = {
    position: 'top-right',
    autoClose: 3000,
  }

  switch (type) {
    case 'success':
      toast.success(message, options)
      break
    case 'error':
      toast.error(message, options)
      break
    case 'info':
      toast.info(message, options)
      break
    case 'warning':
      toast.warning(message, options)
      break
    default:
      toast(message, options)
  }
}
